import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccounts } from '@/renderer/services/accountingService';
import type { AccountFilterParams } from '@/renderer/types/accounting';

export function useAccounts(params: AccountFilterParams) {
  return useQuery({
    queryKey: queryKeys.accounting.accountsList(params),
    queryFn: async () => {
      const result = await fetchAccounts(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch accounts');
      }
      return result.data;
    },
    enabled: !!params.companyId,
    placeholderData: keepPreviousData,
  });
}
